import React from 'react'
import { Heading, Text } from '@plurall/elo'
import PropTypes from 'prop-types'
import {
  messageWrapper,
  messageBlock,
  messageDenied,
  messageText,
  messageTitle,
} from './ContentViewer.module.scss'

const { REACT_APP_ASSETS_URL } = process.env

export const AccessDenied = ({ title, text }) => (
  <div className={messageWrapper} >
    <div className={messageDenied} >
      <img alt='Acesso negado' src={`${REACT_APP_ASSETS_URL}/static/assets/images/what.svg`} />
    </div>
    <div className={messageBlock}>
      <Heading className={messageTitle} size='big' >{ title }</Heading>
      <Text className={messageText}>
        {text}
      </Text>
    </div>
  </div>
)

AccessDenied.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
}

